import lrScanCode from './_src/lrScanCode.vue'

lrScanCode.install = function(Vue) {
  Vue.component(lrScanCode.name, lrScanCode)
}

export default lrScanCode